import dynamic from "next/dynamic";

export const ContentBlocks = dynamic(() => import("./component"));
